import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  Checkbox,
  TextField,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Paper,
} from '@mui/material';
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';

const SubmitWU = ({ open, onClose, transactionName }) => {
  const policyDetails = {
    policyNumber: 'POL-2024-001',
    insured: 'John Smith',
    effectiveDate: '2024-02-01'
  };

  // 简化文件结构，所有文件都是必需的
  const [files, setFiles] = useState([
    { id: 1, name: 'Insurance Application.pdf', selected: true },
    { id: 2, name: 'Insurance Quote.pdf', selected: true },
    { id: 3, name: 'Auto+ Report.pdf', selected: true },
    { id: 4, name: 'Motor Vehicle Record (MVR).pdf', selected: true },
    { id: 5, name: 'Pre-Authorized Credit (PAC) Form.pdf', selected: true },
    { id: 6, name: 'Electronic Signature Consent.pdf', selected: true },
    { id: 7, name: 'AB Form.pdf', selected: true },
    { id: 8, name: 'Vehicle Ownership.pdf', selected: true },
    { id: 9, name: 'Void Cheque.pdf', selected: true },
    { id: 10, name: 'Bill of Sale.pdf', selected: true },
    { id: 11, name: 'Letter of Experience (LOE).pdf', selected: true },
    { id: 12, name: 'Abstract Letter.pdf', selected: true },
    { id: 13, name: 'Winter Tire Photos/Receipts.pdf', selected: true },
    { id: 14, name: 'Vehicle Photos.pdf', selected: true },
    { id: 15, name: 'Document Review Summary.pdf', selected: true }
  ]);
  
  const [remarks, setRemarks] = useState('');

  const handleToggleFile = (fileId) => {
    setFiles(files =>
      files.map(file =>
        file.id === fileId
          ? { ...file, selected: !file.selected }
          : file
      )
    );
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        pb: 2
      }}>
        <Typography variant="h6">
          Submit to Underwriter
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 3 }}>
        {/* Policy Details Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Policy Details
          </Typography>
          <Grid container spacing={2} sx={{ 
            bgcolor: 'background.paper',
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            p: 2,
            mx: 0,
            width: '100%'
          }}>
            <Grid item xs={12} sm={4}>
              <Typography variant="caption" color="text.secondary">
                Policy Number
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {policyDetails.policyNumber}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="caption" color="text.secondary">
                Insured
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {policyDetails.insured}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="caption" color="text.secondary">
                Effective Date
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {policyDetails.effectiveDate}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Documents Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Documents to Submit
          </Typography>
          
          <Paper sx={{ 
            border: '1px solid #e0e0e0',
            borderRadius: 1,
          }}>
            <List disablePadding>
              {files.map((file, index) => (
                <ListItem
                  key={file.id}
                  sx={{
                    py: 1,
                    borderBottom: index < files.length - 1 ? '1px solid #e0e0e0' : 'none',
                  }}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    width: '100%',
                    gap: 1
                  }}>
                    <Checkbox
                      checked={file.selected}
                      onChange={() => handleToggleFile(file.id)}
                      size="small"
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2">
                        {file.name}
                      </Typography>
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Box>

        {/* Remarks Section */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Remarks for Underwriter
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Add any notes or special instructions..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            sx={{ 
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff'
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ 
        p: 2, 
        borderTop: '1px solid #e0e0e0'
      }}>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button 
          variant="contained"
          onClick={() => {
            console.log('Submitting:', files.filter(f => f.selected));
            onClose();
          }}
          disabled={!files.some(file => file.selected)}
        >
          Submit to Underwriter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitWU; 